import React, { useContext } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import Navbar from "./components/Navbar";
import { AuthContext } from "./context/AuthContext";

// Pages...
import Home from "./pages/Home.jsx";
import Login from "./pages/Login/Login";

import SignUp from "./pages/Login/SignUp/SignUp";
import VerifyEmail from "./pages/Login/SignUp/VerifyEmail";
import VerifyNumber from "./pages/Login/SignUp/VerifyNumber";
import ChooseUsernamePassword from "./pages/Login/SignUp/ChooseUsernamePassword";
import ResetPassword from "./pages/Login/ResetPassword/ResetPassword";
import CheckInbox from "./pages/Login/ResetPassword/CheckInbox";
import SetPassword from "./pages/Login/ResetPassword/SetPassword";
import SuccessfulReset from "./pages/Login/ResetPassword/SuccessfulReset";
import Main from "./pages/Main/Main";
import JokerPro from "./pages/JokerPro/JokerPro";
import JokerScratch from "./pages/JokerScratch/JokerScratch";
import Verification from "./pages/Login/ResetPassword/Verification";
import JokerRewards from "./pages/Rewards/JokerRewards";
import JokerDownload from "./pages/Download/JokerDownload";
import Learn from "./pages/Learn/Learn";
import JokerSupport from "./pages/Support/JokerSupport";
import TestPage from "./pages/TestPage/TestPage";
import JokerDownloadApkStep from "./pages/Download/JokerDownloadApkStep";
import PageWrapper from "./pages/PageWrapper";
import Privacy from "./pages/Privacy/Privacy";
import TermsCondition from "./pages/Privacy/TermsCondition";

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element }) => {
  const { isSignedIn } = useContext(AuthContext);
  return isSignedIn ? element : <Navigate to="/login" />;
};

interface PrivateRouteProps {
  element: React.ReactElement;
}

const AppRouter = () => {
  const { loadingAuth } = useContext(AuthContext);
  const location = useLocation();

  if (loadingAuth) return <div>Loading...</div>;

  return (
    <div
      style={{ minHeight: "100dvh", display: "flex", flexDirection: "column" }}
    >
      <Navbar />

      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          {/* Public Routes */}
          <Route
            path="/login"
            element={
              <PageWrapper>
                <Login />
              </PageWrapper>
            }
          />
          <Route
            path="/sign_up"
            element={
              <PageWrapper>
                <SignUp />
              </PageWrapper>
            }
          />
          <Route
            path="/verify_email"
            element={
              <PageWrapper>
                <VerifyEmail />
              </PageWrapper>
            }
          />
          <Route
            path="/privacy"
            element={
              <PageWrapper>
                <Privacy />
              </PageWrapper>
            }
          />
          <Route
            path="/terms_conditions"
            element={
              <PageWrapper>
                <TermsCondition />
              </PageWrapper>
            }
          />
          <Route
            path="/verify_number"
            element={
              <PageWrapper>
                <VerifyNumber />
              </PageWrapper>
            }
          />
          <Route
            path="/choose_username"
            element={
              <PageWrapper>
                <ChooseUsernamePassword />
              </PageWrapper>
            }
          />
          <Route
            path="/reset_password"
            element={
              <PageWrapper>
                <ResetPassword />
              </PageWrapper>
            }
          />
          <Route
            path="/check_inbox"
            element={
              <PageWrapper>
                <CheckInbox />
              </PageWrapper>
            }
          />
          <Route
            path="/verification"
            element={
              <PageWrapper>
                <Verification />
              </PageWrapper>
            }
          />
          <Route
            path="/set_password"
            element={
              <PageWrapper>
                <SetPassword />
              </PageWrapper>
            }
          />
          <Route
            path="/successful_reset"
            element={
              <PageWrapper>
                <SuccessfulReset />
              </PageWrapper>
            }
          />
          <Route
            path="/test"
            element={
              <PageWrapper>
                <TestPage />
              </PageWrapper>
            }
          />

          {/* Private Routes */}
          <Route
            path="/main"
            element={
              <PageWrapper>
                <Main />
              </PageWrapper>
            }
          />
          <Route
            path="/joker_pro"
            element={
              <PageWrapper>
                <JokerPro />
              </PageWrapper>
            }
          />
          <Route
            path="/joker_scratch"
            element={
              <PageWrapper>
                <JokerScratch />
              </PageWrapper>
            }
          />
          <Route
            path="/learn"
            element={
              <PageWrapper>
                <Learn />
              </PageWrapper>
            }
          />
          <Route
            path="/download"
            element={
              <PageWrapper>
                <JokerDownload />
              </PageWrapper>
            }
          />
          <Route
            path="/downloadApk"
            element={
              <PageWrapper>
                <JokerDownloadApkStep />
              </PageWrapper>
            }
          />
          <Route
            path="/rewards_program"
            element={
              <PageWrapper>
                <JokerRewards />
              </PageWrapper>
            }
          />
          <Route
            path="/support"
            element={
              <PageWrapper>
                <JokerSupport />
              </PageWrapper>
            }
          />
          <Route
            path="/home"
            element={
              <PrivateRoute
                element={
                  <PageWrapper>
                    <Home />
                  </PageWrapper>
                }
              />
            }
          />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/main" />} />
        </Routes>
      </AnimatePresence>
    </div>
  );
};

export default AppRouter;
